/**
 * Factory for creating UserService instances based on authentication provider
 */

import AuthenticationProviderEnum from '../../config/authenticationProviderEnum';
import OnecloudUserService from './OnecloudUserService';
import StratusUserService from './StratusUserService';
import IUserService from './IUserService';

/**
 * Parameters for creating UserService strategies
 */
export interface IUserServiceFactoryParams {
  authenticationProvider: AuthenticationProviderEnum;
}

/**
 * Factory Pattern to encapsulate UserService creation logic
 */
export class UserServiceFactory {
  /**
   * Creates the appropriate UserService based on the authentication provider
   */
  static createService(params: IUserServiceFactoryParams): IUserService {
    const { authenticationProvider } = params;

    if (authenticationProvider === AuthenticationProviderEnum.coptor) {
      return new OnecloudUserService();
    } else {
      return new StratusUserService();
    }
  }

  /**
   * Returns available service types
   */
  static getAvailableServices(): string[] {
    return ['OnecloudUserService', 'StratusUserService'];
  }
}
